import React, { useEffect, useState }  from 'react'
import { useDispatch } from 'react-redux'
import {Container, Row, Col, Spinner, Modal, Button, Form} from 'react-bootstrap'
import { css } from 'emotion'
import moment from 'moment'
import 'moment/locale/fr';
import LeMoulinApi from 'app/universal/utils/LeMoulinApi'
import { TEMPERATURES } from 'app/orderTool/pages/pipelineB2b/temperatures'

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list';

import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';

import Layout from 'app/universal/layout/Layout'
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { getSavs } from 'state/sav/actions';

const ON_CALL_TEAM = ['Sophie', 'Julie', 'Valentin'];

const buildOnCallEvent = (date, persons) => {
  if (!persons || persons.length === 0) {
    return null;
  }
  return {
    id: 'oncall-' + date,
    title: 'Astreinte',
    start: new Date(moment(date).format('YYYY/MM/DD')),
    end: new Date(moment(date).format('YYYY/MM/DD')),
    allDay: true,
    name: 'onCall',
    onCallPersons: persons,
  };
};

const getOnCallPersonName = (person) => person.person_name || person.personName || '';

const Agenda = (props) => {

  const dispatch = useDispatch();
  // Permet d'ajouter les dates dans l'url
  let history = useHistory();
  // Les commandes formatées pour le full calendar
  const [orders, setOrders] = useState([]);
  // Les commandes filtrées pour le full calendar
  const [ordersFiltered, setOrdersFiltered] = useState([]);
  // Date de début et de fin du calendrier
  const [dates, setDates] = useState({});
  // Contiendra les dates pour lesquelles la requete order aura deja été faite (pour éviter de les refaire)
  const [dateListing, setDateListing] = useState([]);
  const [newDates, setNewDates]       = useState([]);
  // Etat de la checkbox "annulation uniquement"
  const [isCanceled, setIsCanceled] = useState(false);
  // Filtre par chargé de clientèle
  const [accountManagerFilter, setAccountManagerFilter] = useState('all');
  // Etat de loading pour les données de l'agenda
  const [isLoading, setIsLoading] = useState(false);
  // Evénement cliqué pour le modal de navigation
  const [selectedEvent, setSelectedEvent] = useState(null);
  // Commandes groupées avec un SAV non réglé (pastille bleue)
  const [savGroupedIds, setSavGroupedIds] = useState({});
  const [showOnCallModal, setShowOnCallModal] = useState(false);
  const [selectedOnCallEvent, setSelectedOnCallEvent] = useState(null);
  const [onCallDate, setOnCallDate] = useState(moment().format('YYYY-MM-DD'));
  const [onCallPersonName, setOnCallPersonName] = useState('');
  const [isSavingOnCall, setIsSavingOnCall] = useState(false);
  const [onCallError, setOnCallError] = useState(null);

  useEffect(() => {
    dispatch(getSavs({ non_regle: 1 })).then((resp) => {
      const map = {};
      (resp?.savs || []).forEach((s) => {
        if (s.commande_groupee_id) {
          map[s.commande_groupee_id] = s.reference;
        }
      });
      setSavGroupedIds(map);
    });
  }, [dispatch]);

  // Retourn un object date à partir d'une date au format 'YYYY-MM-DD'
  const getDateObject = (date) => {
    let dateSplited = date.split('-');
    // 07/03/22 - fix, le mois correspond à l'index (donc janvier = 0)
    return new Date(dateSplited[0],dateSplited[1] - 1,dateSplited[2]);
  }

  // Retourne un tableau listant les dates entre deux dates
  const getDatesBetweenTwoDates = (start, end) => {
    var dateArray = [];
    var currentDate = moment(getDateObject(start));
    var stopDate = moment(getDateObject(end));
    // 07/03/22 - lié au fix
    // currentDate = moment(currentDate).subtract(1, 'M');
    // stopDate    = moment(stopDate).subtract(1, 'M');
    while (currentDate < stopDate) {
        dateArray.push( moment(currentDate).format('YYYY-MM-DD') )
        currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
  }

  // Met à jour les states utiles pour les dates
  const changeDates = (dates) => {
    if (dates.start === undefined) {
      return;
    }
    setDates({'start':dates.start,'end':dates.end});
    // Ajoute à l'url
    history.push('?startDate='+dates.start+'&endDate='+dates.end);
    // Liste les nouvelles dates
    let newDateListing = getDatesBetweenTwoDates(dates.start,dates.end);
    newDateListing = newDateListing.filter(x => !dateListing.includes(x))
    // Pas de nouvelles dates
    if (newDateListing.length < 1) {
      return;
    }
    // Ajoute les nouvelles dates
    setNewDates(newDateListing);
    newDateListing = [...new Set([...newDateListing, ...dateListing])]
    setDateListing(newDateListing)
  }

  // Uniquement quand des nouvelles dates ont été ajoutées
  useEffect(() => {
    // Recupère les commandes
    const fetchData = async () => {
      
      if (newDates.length < 1) {
        return;
      }

      setIsLoading(true);
      
      try {
        // 25/01/24 - On veut récuperer toutes les commandes meme celle annulées/refusées
        let params = {
          groups : ['delivery'],
          filters: {
            delivery_date: newDates,
            status       : [101,102,103,400,401,402,411,412]
          },
          include_cancel_order : 1,
          limit: 1000
        }

        const ordersResult = await LeMoulinApi.request.order.gets(params)

        let data = [];
        // 06/23 - ajoute le niveau d'activité
        newDates.map((newDate, i) => {

          // Jour fermé
          let closedDate = ordersResult.closedDates.find((x) => {
            return moment(x).format('YYYY-MM-DD') == newDate;
          });

          // Niveau d'activité
          let activityLevel = ordersResult.activityLevels.find((x) => {
            return moment(x.date).format('YYYY-MM-DD') == newDate;
          });
          
          // Si week end pas d'event sauf si niveau d'activité
          // if (!activityLevel && (moment(newDate).format('dddd') == 'samedi' || moment(newDate).format('dddd') == 'dimanche')) {
          //   return;
          // }
          
          // Si une activité en bdd ou que ce n'est pas un jour fermé
          return data.push({
            'id'   : 'al-'+ newDate,
            'title': "Niveau d'activité",
            'start': new Date(moment(newDate).format('YYYY/MM/DD')),
            'end'  : new Date(moment(newDate).format('YYYY/MM/DD')),
            'allDay': true,
            'name' : 'activityLevel',
            'prLevel': activityLevel ? activityLevel.pr_level : 'low',
            'breakfastLevel': activityLevel ? activityLevel.breakfast_level : 'low',
            'catererLevel': activityLevel ? activityLevel.caterer_level : 'low',
            'prLevelFR': (closedDate || (moment(newDate).format('dddd') == 'samedi' || moment(newDate).format('dddd') == 'dimanche')) ? "fermé" : (activityLevel && activityLevel.pr_level == 'high' ? 'activité bloquée' : activityLevel && activityLevel.pr_level == 'medium' ? 'forte activité' : 'libre'),
            'breakfastLevelFR': activityLevel && activityLevel.breakfast_level == 'high' ? 'activité bloquée' : activityLevel && activityLevel.breakfast_level == 'medium' ? 'forte activité' : 'libre',
            'catererLevelFR': activityLevel && activityLevel.caterer_level == 'high' ? 'activité bloquée' : activityLevel && activityLevel.caterer_level == 'medium' ? 'forte activité' : 'libre',
            'prLevelColor': (closedDate || (moment(newDate).format('dddd') == 'samedi' || moment(newDate).format('dddd') == 'dimanche')) ? "red" : (activityLevel && activityLevel.pr_level == 'high' ? 'red' : activityLevel && activityLevel.pr_level == 'medium' ? 'orange' : 'green'),
            'breakfastLevelColor': activityLevel && activityLevel.breakfast_level == 'high' ? 'red' : activityLevel && activityLevel.breakfast_level == 'medium' ? 'orange' : 'green',
            'catererLevelColor': activityLevel && activityLevel.caterer_level == 'high' ? 'red' : activityLevel && activityLevel.caterer_level == 'medium' ? 'orange' : 'green',
          });
          
        });

        (ordersResult.onCallPersons || []).forEach((person) => {
          const personDate = moment(person.date).format('YYYY-MM-DD');
          if (!newDates.includes(personDate)) {
            return;
          }
          const existingEvent = data.find((eventItem) => eventItem.id === 'oncall-' + personDate);
          if (existingEvent) {
            if (!existingEvent.onCallPersons.some((p) => p.id === person.id)) {
              existingEvent.onCallPersons.push(person);
            }
            return;
          }
          const onCallEvent = buildOnCallEvent(personDate, [person]);
          if (onCallEvent) {
            data.push(onCallEvent);
          }
        });
        
        ordersResult.orders.map((order, i) => {
          return data.push({
            'id' : order.id,
            'title' : order.delivery.company,
            'start' : order.delivery.arrived_at_start ? new Date(moment(order.delivery.delivery_date).format('YYYY/MM/DD')+' '+moment(order.delivery.arrived_at_start).format('HH:mm')) : new Date(moment(order.delivery.delivery_date).format('YYYY/MM/DD')),
            'end' : order.delivery.arrived_at_start ? new Date(moment(order.delivery.delivery_date).format('YYYY/MM/DD')+' '+moment(order.delivery.arrived_at_start).format('HH:mm')) : new Date(moment(order.delivery.delivery_date).format('YYYY/MM/DD')),
            'name' : order.lastname,
            'format' : order.format,
            'type' : order.delivery.prestation_type,
            'status' : order.status,
            'nbPerso' : order.participants_number,
            'numbering': order.numbering,
            'orderNumber': order.info?.orderNumber,
            'groupedOrderId': order.grouped_order_id,
            'orderIndex': order.info?.order_index,
            'confirmed_number' : order.confirmed_participants_number,
            'url': order.info.quotation_url,
            'editUrl': order.info.edit_url,
            'service': order.delivery.service,
            'hasZeroWasteProduct' : order.info.hasZeroWasteProduct,
            'cancelDate' : order.cancel_date,
            'temperature': order.grouped_order_temperature,
            'accountManager': order.account_manager || null
          })
        });
        
        setOrders(o => data.concat(o));
        // Etat initial après requete - On filtre les commandes récupérées en excluant les annulées et refusées
        data = data.filter((o) => ((o.status < 400 && (o.cancelDate === null || o.cancelDate === undefined)) || (o.title == "Niveau d'activité") || o.name === 'onCall'));
        if (accountManagerFilter !== 'all') {
          data = data.filter((o) => o.accountManager === accountManagerFilter || o.title === "Niveau d'activité" || o.name === 'onCall');
        }
        setOrdersFiltered(o => data.concat(o));
      } catch (error) {
        console.error('Erreur lors du chargement des données:', error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchData()

  }, [newDates]);
  
  // Récupère les dates du calendrier au chargement de la page
  const onCalendarLoading = (calendarApi) => {
    if (calendarApi.view !== undefined && calendarApi.view.activeStart !== undefined) {
      if (dates.start !== calendarApi.view.activeStart.getFullYear()+'-'+(calendarApi.view.activeStart.getMonth() + 1)+'-'+calendarApi.view.activeStart.getDate()) {
        // setDates({'start':calendarApi.view.activeStart.getFullYear()+'-'+(calendarApi.view.activeStart.getMonth() + 1)+'-'+calendarApi.view.activeStart.getDate(),'end':calendarApi.view.activeEnd.getFullYear()+'-'+(calendarApi.view.activeEnd.getMonth() + 1)+'-'+calendarApi.view.activeEnd.getDate()})
        changeDates({'start':calendarApi.view.activeStart.getFullYear()+'-'+(calendarApi.view.activeStart.getMonth() + 1)+'-'+calendarApi.view.activeStart.getDate(),'end':calendarApi.view.activeEnd.getFullYear()+'-'+(calendarApi.view.activeEnd.getMonth() + 1)+'-'+calendarApi.view.activeEnd.getDate()})
      }
    }
  }

  // Récupère les dates du calendrier qu changement du mois
  const changeMonth = (event) => {
      if (calendarRef.current) {
        let calendarApi = calendarRef.current.getApi();
        let activeRange = calendarApi.state.dateProfile.activeRange;
        let startDate   = activeRange.start;
        let endDate     = activeRange.end;
        changeDates({'start':startDate.getFullYear()+'-'+(startDate.getMonth() + 1)+'-'+startDate.getDate(),'end':endDate.getFullYear()+'-'+(endDate.getMonth() + 1)+'-'+endDate.getDate()})
      }
  }
  document.addEventListener('click', changeMonth);

  const EventMonth = ({ event, el, view }) => {

    var start            = event.start;
    var title            = event._def.title;
    var name             = event._def.extendedProps.name;
    var kind             = event._def.extendedProps.type;
    var type             = event._def.extendedProps.format;
    var numbering        = event._def.extendedProps.numbering;
    var orderNumber      = event._def.extendedProps.orderNumber;
    var nbPerso          = event._def.extendedProps.nbPerso;
    var status           = event._def.extendedProps.status;
    var confirmed_number = event._def.extendedProps.confirmed_number;
    var service          = event._def.extendedProps.service;
    var hasZeroWasteProduct          = event._def.extendedProps.hasZeroWasteProduct;
    var cancelDate       = event._def.extendedProps.cancelDate;
    var accountManager   = event._def.extendedProps.accountManager;
    var groupedOrderId   = event._def.extendedProps.groupedOrderId;
    var savRef           = groupedOrderId ? savGroupedIds[groupedOrderId] : null;
    // Pastille SAV : même format (20px rond) que Service (rouge) / Zéro déchet (vert)
    // Température du devis (🔥 / 🌤 / ❄️), seulement pour les devis en attente non annulés
    // (retour de Julie, 30/10) : rien pour les devis validés ni pour les annulés.
    var temperatureDef   = TEMPERATURES[event._def.extendedProps.temperature];
    var temperatureMark  = (temperatureDef && String(status) === '101' && (cancelDate === null || cancelDate === undefined))
      ? " <span title='" + temperatureDef.libelle + "'>" + temperatureDef.emoji + "</span>"
      : "";
    var savDot           = savRef ? "<span style='width:20px;height:20px; background-color:#4a90d9; color:#4a90d9; display: inline-block;border-radius: 50px;' title='SAV "+savRef+"'></span>" : "";

    // `format` peut être undefined sur certains events (notamment v2 brique
    // mode où le format n'est pas toujours présent). On normalise en '' pour
    // éviter "Cannot read properties of undefined (reading 'includes')".
    type = type || '';

    if ( type === 'mealtray' )
      type = "Plateaux-repas";
    else if ( type.includes('buffet') )
      type = "Buffet";
    else if ( type === 'salad_bowl' )
      type = "Saladiers";
    else if ( type === 'packed_lunch' )
      type = "Repas nomades";
    else if ( kind === 'breakfast' )
      type = "Petit déjeuner - " + type;
    else if ( kind === 'caterer' )
      type = "Traiteur - " + type;

    var bgColor = (kind === 'mealtray' || kind === 'v2') ? 'lightgrey' : kind === 'caterer' ? 'lightblue' : kind === 'breakfast' ? 'lightgreen' : name === 'activityLevel' || name === 'closedDate' ? 'white' : name === 'onCall' ? '#e8ddff' : 'orange';
    
    var bgColor = (status >= 400 || (cancelDate !== null && cancelDate !== undefined)) ? 'red' : bgColor;

    var borderBottom = (
      status === '101'
        ?
      'orange'
        :
      ((status === '102' || status === '103') && confirmed_number === true)
        ?
      'green'
        :
      ((status === '102' || status === '103') && (confirmed_number === null || confirmed_number === false))
        ?
      'yellow'
        :
      'red');

    if(numbering === undefined){ numbering = "" }
    var ref = numbering + (orderNumber ? " / " + orderNumber : "");

    var styles = "overflow: hidden;white-space: nowrap;text-align:center;border:none;background-color:"+bgColor+";color:black;margin-bottom:3px;font-size:0.8rem;border-bottom-style:solid;border-bottom-color:"+borderBottom+";border-bottom-width:3px;    display: block;"

    el.setAttribute("style", styles);

    var cdcParts = [numbering, orderNumber, accountManager].filter(Boolean).join(' · ');
    var cdcLine = cdcParts ? "<br/><span style='font-size:0.7rem;color:#4a90d9;'>" + cdcParts + "</span>" : "";

    // 06/23 - Ajoute l'activité
    if (name == 'activityLevel'){
      el.innerHTML = "<span><span style='background-color:"+event._def.extendedProps.prLevelColor+";'>PR : " + event._def.extendedProps.prLevelFR +"</span><br/> <span style='background-color:"+event._def.extendedProps.catererLevelColor+";'>Cockt :" + event._def.extendedProps.catererLevelFR +"</span><br/> <span style='background-color:"+event._def.extendedProps.breakfastLevelColor+";'>PDJ :" + event._def.extendedProps.breakfastLevelFR +"</span></span>"
    }
    else if (name === 'onCall') {
      const labels = (event._def.extendedProps.onCallPersons || [])
        .map((person) => getOnCallPersonName(person))
        .filter(Boolean)
        .join(', ');
      el.innerHTML = "<span style='background-color:#6f42c1;color:white;padding:2px 6px;border-radius:4px;display:inline-block;'>Astreinte : " + labels + "</span>";
    }
    else if((status >= 400 || (cancelDate !== null && cancelDate !== undefined))){
      el.innerHTML = "<b>- ANNULÉE - </b><span>" + title + "<br/>" + name + " " + nbPerso +" pers<br/>" + type + cdcLine + "</span>"
    }
    else if (name == 'closedDate'){
      el.innerHTML = "<span style='background-color:red;'>PR fermé</span>"
    }
    else if((hasZeroWasteProduct === true || hasZeroWasteProduct === 1) && (service === true || service === 1)){
      el.innerHTML = "<span>" + moment(start).format('HH:mm') + "- <strong>" + title + "</strong>" + temperatureMark + "<br/> " + name + " " + nbPerso +" pers <span style='width:20px;height:20px; background-color: red; color: red; display: inline-block;border-radius: 50px;'></span><span style='width:20px;height:20px; background-color:#94c42c; color: white; display: inline-block;border-radius: 50px;'></span>" + savDot + "<br/>" +type+ cdcLine +"</span>"
    }
    else if(hasZeroWasteProduct === true || hasZeroWasteProduct === 1){
      el.innerHTML = "<span>" + moment(start).format('HH:mm') + "- <strong>" + title + "</strong>" + temperatureMark + "<br/> " + name + " " + nbPerso +" pers <span style='width:20px;height:20px; background-color:#94c42c; color: white; display: inline-block;border-radius: 50px;'></span>" + savDot + "<br/>" +type+ cdcLine +"</span>"
    }
    else if(service === true || service === 1){
      el.innerHTML = "<span>" + moment(start).format('HH:mm') + "- <strong>" + title + "</strong>" + temperatureMark + "<br/> " + name + " " + nbPerso +" pers <span style='width:20px;height:20px; background-color: red; color: red; display: inline-block;border-radius: 50px;'></span>" + savDot + "<br/>" +type+ cdcLine +"</span>"
    }
    else{
      el.innerHTML = "<span>" + moment(start).format('HH:mm') + "- <strong>" + title + "</strong>" + temperatureMark + "<br/> " + name + " " + nbPerso +" pers " + savDot + "<br/>" +type+ cdcLine +"</span>"
    }


  }
  const eventClick = (info) => {
    info.jsEvent.preventDefault();
    if (info.event._def.extendedProps.name === 'onCall') {
      setSelectedOnCallEvent({
        date: moment(info.event.start).format('YYYY-MM-DD'),
        onCallPersons: info.event._def.extendedProps.onCallPersons || [],
      });
      return;
    }
    if (info.event.url) {
      setSelectedEvent({
        url: info.event.url,
        title: info.event._def.title,
        numbering: info.event._def.extendedProps.numbering,
        orderNumber: info.event._def.extendedProps.orderNumber,
        start: info.event.start,
        id: info.event.id,
        groupedOrderId: info.event._def.extendedProps.groupedOrderId,
        orderIndex: info.event._def.extendedProps.orderIndex,
        format: info.event._def.extendedProps.format,
      });
    }
  }

  const applyFiltersToList = (canceled, cdcFilter, source) => {
    let filtered = source || [];
    if (canceled) {
      filtered = filtered.filter((o) => ((o.status >= 400 || (o.cancelDate !== null && o.cancelDate !== undefined)) || (o.title === "Niveau d'activité") || o.name === 'onCall'));
    } else {
      filtered = filtered.filter((o) => ((o.status < 400 && (o.cancelDate === null || o.cancelDate === undefined)) || (o.title === "Niveau d'activité") || o.name === 'onCall'));
    }
    if (cdcFilter !== 'all') {
      filtered = filtered.filter((o) => o.accountManager === cdcFilter || o.title === "Niveau d'activité" || o.name === 'onCall');
    }
    return filtered;
  };

  const applyFilters = (canceled, cdcFilter, source) => {
    setOrdersFiltered(applyFiltersToList(canceled, cdcFilter, source || orders));
  };

  const upsertOnCallEventInLists = (date, person) => {
    const eventId = 'oncall-' + date;
    const mergeEvent = (eventList) => {
      const existingIndex = eventList.findIndex((eventItem) => eventItem.id === eventId);
      if (existingIndex === -1) {
        const onCallEvent = buildOnCallEvent(date, [person]);
        return onCallEvent ? [onCallEvent, ...eventList] : eventList;
      }
      const updated = [...eventList];
      const persons = [...(updated[existingIndex].onCallPersons || [])];
      if (!persons.some((p) => p.id === person.id)) {
        persons.push(person);
      }
      updated[existingIndex] = {
        ...updated[existingIndex],
        onCallPersons: persons,
      };
      return updated;
    };

    setOrders((prev) => mergeEvent(prev));
    setOrdersFiltered((prev) => applyFiltersToList(isCanceled, accountManagerFilter, mergeEvent(prev)));
  };

  const removeOnCallPersonFromLists = (date, personId) => {
    const eventId = 'oncall-' + date;
    const pruneEvent = (eventList) => {
      const existingIndex = eventList.findIndex((eventItem) => eventItem.id === eventId);
      if (existingIndex === -1) {
        return eventList;
      }
      const remainingPersons = (eventList[existingIndex].onCallPersons || []).filter((p) => p.id !== personId);
      if (remainingPersons.length === 0) {
        return eventList.filter((eventItem) => eventItem.id !== eventId);
      }
      const updated = [...eventList];
      updated[existingIndex] = {
        ...updated[existingIndex],
        onCallPersons: remainingPersons,
      };
      return updated;
    };

    setOrders((prev) => pruneEvent(prev));
    setOrdersFiltered((prev) => applyFiltersToList(isCanceled, accountManagerFilter, pruneEvent(prev)));
  };

  const openOnCallModal = (date) => {
    setOnCallDate(date || moment().format('YYYY-MM-DD'));
    setOnCallPersonName('');
    setOnCallError(null);
    setShowOnCallModal(true);
  };

  const handleAddOnCall = async () => {
    const trimmedName = onCallPersonName.trim();
    if (!onCallDate || !trimmedName) {
      setOnCallError('La date et le nom sont obligatoires.');
      return;
    }

    setIsSavingOnCall(true);
    setOnCallError(null);
    try {
      const response = await LeMoulinApi.request.agenda.onCall.post({
        date: onCallDate,
        person_name: trimmedName,
      });
      const createdPerson = response;
      upsertOnCallEventInLists(onCallDate, createdPerson);
      setShowOnCallModal(false);
      if (selectedOnCallEvent && selectedOnCallEvent.date === onCallDate) {
        setSelectedOnCallEvent((prev) => ({
          ...prev,
          onCallPersons: [...(prev.onCallPersons || []), createdPerson],
        }));
      }
    } catch (error) {
      const message = error?.response?.data?.message || "Impossible d'ajouter l'astreinte.";
      setOnCallError(message);
    } finally {
      setIsSavingOnCall(false);
    }
  };

  const handleDeleteOnCall = async (person) => {
    if (!person?.id) {
      return;
    }
    const personDate = selectedOnCallEvent?.date || moment(person.date).format('YYYY-MM-DD');
    try {
      await LeMoulinApi.request.agenda.onCall.delete(person.id);
      removeOnCallPersonFromLists(personDate, person.id);
      setSelectedOnCallEvent((prev) => {
        if (!prev) {
          return prev;
        }
        const remaining = (prev.onCallPersons || []).filter((p) => p.id !== person.id);
        if (remaining.length === 0) {
          return null;
        }
        return {
          ...prev,
          onCallPersons: remaining,
        };
      });
    } catch (error) {
      console.error("Erreur lors de la suppression de l'astreinte:", error);
    }
  };

  // Fonction pour inverser l'état de la checkbox lorsqu'elle est cliquée + filtrage
  const handleIsCanceledChange = () => {
    const next = !isCanceled;
    setIsCanceled(next);
    applyFilters(next, accountManagerFilter);
  };

  const handleAccountManagerFilterChange = (value) => {
    setAccountManagerFilter(value);
    applyFilters(isCanceled, value);
  };

  const calendarRef = React.createRef();
  return (
    <Layout>
      <Helmet>
        <title>Agenda</title>
      </Helmet>
      <Container fluid={true}>
        <div className={css(styles.calendar)}>
          <Row>
              <Col xs={12} sm={4}>
              <p>
                <small>Légende :  <span className={css(styles.pastilleRed)}></span> Service, <span className={css(styles.pastilleGreen)}></span> Zéro déchet, <span className={css(styles.pastilleBlue)}></span> SAV en cours, <span className={css(styles.pastillePurple)}></span> Astreinte </small><br/>
              </p>
              </Col>
              <Col xs={12} sm={2} className="text-right">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => openOnCallModal(moment().format('YYYY-MM-DD'))}
                >
                  Ajouter une astreinte
                </Button>
              </Col>
              <Col xs={12} sm={3}>
                <p className="text-right">
                  <input
                    type="checkbox"
                    checked={isCanceled}
                    onChange={handleIsCanceledChange}
                    id="isCanceled"
                  /> <label htmlFor="isCanceled"><small> Commandes annulées uniquement</small></label>
                </p>
              </Col>
              <Col xs={12} sm={3}>
                <p className="text-right">
                  <select
                    value={accountManagerFilter}
                    onChange={(e) => handleAccountManagerFilterChange(e.target.value)}
                    style={{ fontSize: '0.85rem', padding: '2px 6px', border: '1px solid #ccc', borderRadius: '4px' }}
                  >
                    <option value="all">Tous les CdC</option>
                    <option value="Camille">Camille</option>
                    <option value="Julie">Julie</option>
                    <option value="Valentin">Valentin</option>
                  </select>
                </p>
              </Col>
            </Row>
            
            {isLoading && (
              <Row className="mb-3">
                <Col className="text-center">
                  <Spinner animation="border" role="status" variant="primary">
                    <span className="sr-only">Chargement...</span>
                  </Spinner>
                  <span className="ml-2">Chargement des données de l'agenda...</span>
                </Col>
              </Row>
            )}
            
        <FullCalendar
          eventClick={eventClick}
          viewSkeletonRender={onCalendarLoading}
          defaultView="dayGridWeek"
          plugins={[ dayGridPlugin, listPlugin ]}
          events={ordersFiltered}
          eventRender={EventMonth}
          locale="frLocale"
          firstDay={1}
          ref={calendarRef}
          views= {{
            dayGridMonth: { buttonText: 'Agenda par mois' },
            dayGridWeek: { buttonText: 'Agenda par semaine' },
            dayGridDay: { buttonText: 'Agenda par jour' }
          }}
          header={{
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth, dayGridWeek'
          }}
          />
        </div>
      </Container>

      {selectedEvent && (
        <Modal show={true} onHide={() => setSelectedEvent(null)} centered size="sm">
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: '1rem' }}>
              {[selectedEvent.numbering, selectedEvent.orderNumber].filter(Boolean).join(' · ') && (
                <small className="text-muted mr-2">{[selectedEvent.numbering, selectedEvent.orderNumber].filter(Boolean).join(' · ')}</small>
              )}
              {selectedEvent.title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="d-flex flex-column" style={{ gap: '8px' }}>
            <Button
              variant="primary"
              onClick={() => { window.open(selectedEvent.url, '_blank'); setSelectedEvent(null); }}
            >
              Fiche de prod
            </Button>
            <Button
              variant="outline-secondary"
              onClick={() => {
                const date = moment(selectedEvent.start).format('YYYY-M-D');
                const params = new URLSearchParams({
                  startDate: date,
                  endDate: date,
                  type: 'quotation',
                  status: 'all_valid',
                  format: 'all',
                  chorus: 'false',
                  limit: '10',
                  offset: '0',
                  orderBy: 'ASC',
                  is_cancel: 'false',
                  to_upload_on_chorus: 'false',
                  exclude_tender_order: 'false',
                  only_service: 'false',
                  selectedOrders: '[]',
                  order_id: selectedEvent.groupedOrderId,
                  order_type: selectedEvent.format,
                  order_index: selectedEvent.orderIndex ?? '1',
                });
                window.open(`/commande?${params.toString()}`, '_blank');
                setSelectedEvent(null);
              }}
            >
              Édition du devis
            </Button>
          </Modal.Body>
        </Modal>
      )}

      {showOnCallModal && (
        <Modal show={true} onHide={() => setShowOnCallModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Ajouter une astreinte</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label>Date</Form.Label>
                <Form.Control
                  type="date"
                  value={onCallDate}
                  onChange={(e) => setOnCallDate(e.target.value)}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Personne</Form.Label>
                <Form.Control
                  type="text"
                  list="on-call-team-list"
                  placeholder="Nom de la personne d'astreinte"
                  value={onCallPersonName}
                  onChange={(e) => setOnCallPersonName(e.target.value)}
                />
                <datalist id="on-call-team-list">
                  {ON_CALL_TEAM.map((name) => (
                    <option key={name} value={name} />
                  ))}
                </datalist>
              </Form.Group>
              {onCallError && (
                <p className="text-danger mb-0">{onCallError}</p>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowOnCallModal(false)}>
              Annuler
            </Button>
            <Button variant="primary" onClick={handleAddOnCall} disabled={isSavingOnCall}>
              {isSavingOnCall ? 'Enregistrement...' : 'Ajouter'}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {selectedOnCallEvent && (
        <Modal show={true} onHide={() => setSelectedOnCallEvent(null)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              Astreinte du {moment(selectedOnCallEvent.date).format('DD/MM/YYYY')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(selectedOnCallEvent.onCallPersons || []).length === 0 ? (
              <p className="mb-0 text-muted">Aucune personne en astreinte.</p>
            ) : (
              (selectedOnCallEvent.onCallPersons || []).map((person) => (
                <div key={person.id} className="d-flex justify-content-between align-items-center mb-2">
                  <span>{getOnCallPersonName(person)}</span>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleDeleteOnCall(person)}
                  >
                    Retirer
                  </Button>
                </div>
              ))
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => {
                openOnCallModal(selectedOnCallEvent.date);
                setSelectedOnCallEvent(null);
              }}
            >
              Ajouter une personne
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Layout>
  )

}


const styles = {
  calendar: {
    padding: '10px 20px'
  },
  pastilleRed:{
    'width': '15px',
    'height':'15px', 
    'backgroundColor': 'red',
    'color': 'red',
    'display': 'inline-block',
    'borderRadius': '50px'
  },
  pastilleGreen:{
    'width': '15px',
    'height':'15px',
    'backgroundColor': '#94c42c',
    'color': 'red',
    'display': 'inline-block',
    'borderRadius': '50px'
  },
  pastilleBlue:{
    'width': '15px',
    'height':'15px',
    'backgroundColor': '#4a90d9',
    'color': '#4a90d9',
    'display': 'inline-block',
    'borderRadius': '50px'
  },
  pastillePurple:{
    'width': '15px',
    'height':'15px',
    'backgroundColor': '#6f42c1',
    'color': '#6f42c1',
    'display': 'inline-block',
    'borderRadius': '50px'
  }
}

export default Agenda
